module.exports = __webpack_public_path__ + "img/NoPath.54a06a0d.png";